<template>
  <div style="width: calc(100vw - 560px);" >
    <div style="margin-bottom: 10px" class="df both-side">
      <a-space>
        <a-input
          placeholder="请输入昵称"
          v-model:value="requestPayload.nickName"
          @change="handleSearch"
          allowClear
        ></a-input>
      </a-space>
      <a-button @click="handleUpeateStaff(null)">新增</a-button>
    </div>
    <div style="height: calc(100vh - 275px)">
      <a-table
        :data-source="table.data"
        bordered
        :pagination="false"
        :columns="columns"
        rowKey="id"
        :scroll="{ x: 'calc(100vw - 580px)', y: 'calc(100vh - 350px)' }"
      >
        <template #isDL="{ record }">
          {{ record.isDL ? "是" : "否" }}
        </template>

        <template #action="{ record }">
          <a-space>
            <a-button
              type="primary"
              @click="handleUpeateStaff(record)"
              size="small"
              >修改</a-button
            >

            <a-button
              type="danger"
              @click="handleDeleteUser(record)"
              size="small"
            >
              删除
            </a-button>
          </a-space>
        </template>
      </a-table>
    </div>

    <div style="margin-top: 10px" class="df both-side">
      <div></div>
      <a-pagination
        size="small"
        :total="table.total"
        v-model:current="table.pageNum"
        v-model:pageSize="table.lineNum"
        @change="handleUpdatePage"
        :show-total="(total) => `共 ${total} 条`"
      />
    </div>
  </div>

  <staff-from ref="staffForm" @updateTable="updateTable"></staff-from>
</template>

<script>
import { defineComponent, reactive, ref, watch } from "vue";
import { useTable } from "@/views/notice/serve/table";
import { deleteUser } from "@/request/view/personal";
import { useRouter } from "vue-router";
import { debounce } from "@/utils";
import staffFrom from "@/views/personnelManagement/component/staff/staffForm.vue";

export default defineComponent({
  components: { staffFrom },
  props: {
    userList: Array,
  },
  setup(props, context) {
    const staffForm = ref();
    const router = useRouter();

    const orignData = [];

    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
    } = useTable();

    initPayload({
      nickName: null,
    });

    const columns = [
      {
        title: "工号",
        dataIndex: "jobNumber",
        align: "center",
        width: "80px",
        fixed: "left"
      },
      {
        title: "昵称",
        dataIndex: "nickName",
        align: "center",
        width: "100px",
      },
      {
        title: "一级部门",
        dataIndex: "firstLevelDepartment",
        align: "center",
        width: "120px",
      },
      {
        title: "二级部门",
        dataIndex: "secondaryDepartment",
        align: "center",
        width: "120px",
      },
      {
        title: "部门主管",
        dataIndex: "isDL",
        align: "center",
        width: "110px",
        slots: {
          customRender: "isDL",
        },
      },
      {
        title: "职位",
        dataIndex: "post",
        align: "center",
        width: "120px",
      },
      {
        title: "直属领导",
        dataIndex: "reportTo",
        align: "center",
        width: "100px",
      },
      {
        title: "入职时间",
        dataIndex: "entryTime",
        align: "center",
        width: "120px",
      },
      {
        title: "备注",
        dataIndex: "notes",
        align: "center",
      },
      {
        title: "操作",
        slots: {
          customRender: "action",
        },
        align: "center",
        width: "160px",
      },
    ];

    const getLocalData = (params) => {
      const endIndex = params.lineNum * params.pageNum;

      const startIndex = (params.pageNum - 1) * params.lineNum;

      return new Promise((resolve, reject) => {
        resolve({
          code: 200,
          data: {
            records: orignData.slice(startIndex, endIndex),
            total: orignData.length,
          },
        });
      });
    };

    requestConfig.pull_fn = getLocalData;
    requestConfig.delete_fn = deleteUser;

    const handleUpeateStaff = (record) => {
      staffForm.value.showModal({
        data: record,
        type: record === null ? "insert" : "update",
        title: record === null ? "新增员工信息" : "更新员工信息",
      });
    };

    const handleProjectDetails = (record) => {
      console.log(record);
    };

    const getData = () => {
      getListData();
    };

    const handleUpdatePage = (pageNum, lineNum) => {
      table.pageNum = pageNum;
      table.lineNum = lineNum;
      getData();
    };

    const handleSearch = debounce(() => {
      orignData.length = 0;

      console.log(requestPayload.nickName);

      if (requestPayload.nickName) {
        const list = props.userList.filter(
          (f) => f.nickName.indexOf(requestPayload.nickName) !== -1
        );
        orignData.push(...list);
      } else {
        orignData.push(...props.userList);
      }

      table.pageNum = 1;
      getData();
    }, 200);

    const handleDeleteUser = (record) => {
      deleteRecords([record.id], { title: "确定删除该员工？" }).then(() => {
        context.emit("updateTable");
      });
    };

    const updateTable = (isInsert) => {
      if (isInsert) {
        table.pageNum = 1;
      }
      context.emit("updateTable");
    };

    watch(
      () => props.userList,
      (val) => {
        if (val) {
          orignData.length = 0;
          orignData.push(...val);
        }
        handleSearch();
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      table,
      columns,
      staffForm,
      requestPayload,
      handleDeleteUser,
      updateTable,
      handleSearch,
      handleUpdatePage,
      handleProjectDetails,
      handleUpeateStaff,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
